import { Injectable } from '@angular/core'
import { ODataConfiguration } from '@exchange/services/core/odata'
import { IModelBase } from 'common-components'
import { HttpClient } from '@angular/common/http'
import { ODataService } from 'common-services'

export interface IClaimExport extends IModelBase {
  Id: number
  ClaimExportConfigId: number
}

@Injectable()
export class ClaimExportODataService extends ODataService<IClaimExport> {
  constructor(
    protected http: HttpClient,
    protected config: ODataConfiguration
  ) {
    super(http, config)
    this.typeName = 'ClaimExports'
  }
}
